import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
import ECommForm from "../ecommForm";
import ECommSession, { ECommStripePaymentProvider } from "../ecomm";
import * as Mustache from "mustache";

export default class EventPaymentFormJs {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    async init(container$, products, event) {
        this.container$ = container$;

        this.form$ = container$.find("form");
        this.submitButton$ = this.form$.find("[type='submit']");
        this.successMessage$ = container$.find(".success");

        this.attendeeTemplateList$ = this.container$.find(".attendeeList");
        this.attendeeAddButton$ = this.container$.find("[data-action='NewAttendee']");

        this.submitting = false;

        //Form init:
        this.products = products;
        this.event = event;
        this.total$ = this.container$.find("[name='Total']");

        let attendeeContent$ = this.container$.find("[data-template='EventAttendee']");
        this.attendeeTemplate = attendeeContent$[0].outerHTML;
        attendeeContent$.remove();

        this.addAttendee();
        this.attendeeAddButton$.on("click", () => { this.addAttendee(); });

        //EComm init:
        const pp = new ECommStripePaymentProvider({
            paymentProviderReferenceName: ECommSettings.StripePaymentProvider
        });

        this.session = new ECommSession();
        await this.session.initAsync({
            paymentProvider: pp
        });

        this.ecommFields = new ECommForm(container$);

    }

    calculateTotal() {
        var amounts$ = this.container$.find("[name='amount']");
        var total = 0;
        amounts$.each(function () {
            total += parseFloat($(this).val());
        });
        this.total$.val(total);
    }

    addAttendee() {
        const newTemplate = Mustache.render(this.attendeeTemplate, {});
        const attendeeTemplate$ = $(newTemplate);

        attendeeTemplate$.find("select[name='measure']").on("change", (ev) => {
            const measure = this.getMeasure(ev.target.value);
            attendeeTemplate$.find("[name='amount']").val(measure.Amount / 100);
            this.calculateTotal();
        });

        attendeeTemplate$.find("[data-action='RemoveAttendee']").on("click", () => {
            attendeeTemplate$.remove();
            attendeeTemplate$ = null;
            this.calculateTotal();
        });

        this.attendeeTemplateList$.append(attendeeTemplate$);
        this.calculateTotal();
    }

    getMeasure(id) {
        id = parseInt(id);
        for (var i = 0; i < this.products.length; i++)
            if (this.products[i].MeasureID == id)
                return this.products[i];
        return null;
    }

    async paymentSubmit() {
        const info = this.ecommFields.getCustomerInfo();

        const attendees = this.container$.find("[data-template='EventAttendee']")
            .toArray()
            .map(atd => {
                const atd$ = $(atd);
                return {
                    MeasureID: atd$.find("[name='measure']").val(),
                    MeasureName: atd$.find("[name='measure'] option:selected").text(),
                    FirstName: atd$.find("[name='firstname']").val(),
                    LastName: atd$.find("[name='lastname']").val(),
                    EmailAddress: atd$.find("[name='email']").val(),
                    CompanyHospital: atd$.find("[name='companyorhospital']").val()
                }
            });

        const session = this.session;
        await session.getCustomer().updateInfo({
            info: info.Info
        });

        let customer = session.getCustomer();
        let order = await customer.newOrderAsync();

        const distinctMeasures = this.container$
            .find("select[name='measure']")
            .toArray()
            .map(s => $(s).val())
            .reduce((obj, mid) => {
                if (obj[mid] == null) obj[mid] = 0;
                obj[mid]++;
                return obj;
            }, {});
        const keys = Object.keys(distinctMeasures);
        for (let i = 0; i < keys.length; i++) {
            const measureCount = distinctMeasures[keys[i]];
            const product = this.getMeasure(keys[i]);
            await order.addItemAsync({
                variantID: product.VariantID,
                measureID: product.MeasureID,
                description: this.event.EventTitle + " - " + product.Title,
                quantity: measureCount,
                additionalJSON: {
                    EventID: this.event.ContentID,
                    EventTitle: this.event.EventTitle,
                    EventAttendees: attendees.filter(atd => atd.MeasureID == product.MeasureID)
                }
            });
        }
        const notes = this.utilsjs.prettyPrintJSON(attendees);
        await order.checkoutAsync({
            shippingAddress: info.ShippingAddress,
            billingAddress: info.BillingAddress,
            notes
        });
    }

    async postEventPaymentForm(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {
        e.preventDefault();

        if (this.submitting) return;
        this.submitting = true;

        var that = this;

        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedEventMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'eventPaymentFormPage' });

        //Transaction:
        try {
            this.ecommFields.hideError();
            await this.paymentSubmit();

            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedEventMessage");
            that.utilsjs.hideById("customFailedDuesMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;
        } catch (ex) {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("customFailedDuesMessage");
            that.utilsjs.hideById(successMessageId);
        }

        //UGC:
        //if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'JobPostingFormPost', 'Module') === '201') {
        //    that.utilsjs.hideById(loadingId);
        //    that.utilsjs.showInlineById(successMessageId);
        //    that.utilsjs.hideById(failedMessageId);
        //    that.utilsjs.hideById(inputSectionId);
        //    document.getElementById(iconId).src = successIconUrl;
        //} else {
        //    that.utilsjs.hideById(loadingId);
        //    that.utilsjs.showById(failedMessageId);
        //    that.utilsjs.hideById(successMessageId);
        //}
        button.disabled = false;
        this.submitting = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/eventPaymentForm.js